import Cookies from "js-cookie";
export const token = Cookies.get("x-access-token"); // Altere para o nome do cookie que você definiu anteriormente.

export async function request(url, options) {
  try {
    return fetch(process.env.REACT_APP_API_RB + url, {
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      ...options,
    })
      .then(checkStatus)
      .then(parseJSON)
      .catch((err) => {
        throw new Error(err);
      });
  } catch (err) {
    throw new Error(err);
  }
}

export async function doRequest(
  url,
  options,
  headers = {
    "x-access-token": token,
  }
) {
  try {
    return fetch(process.env.REACT_APP_API_RB + url, {
      headers: headers,
      ...options,
    })
      .then(checkStatus)
      .then(parseJSON)
      .catch((err) => {
        throw new Error(err);
      });
  } catch (err) {
    throw new Error(err);
  }
}

export async function requestWithImage(url, options) {
  const token = Cookies.get("x-access-token"); // Altere para o nome do cookie que você definiu anteriormente.

  if (options.body instanceof FormData) {
    console.log("FormData content:");
    for (let pair of options.body.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }
  } else {
    console.log("Non-FormData content:", options.body);
  }
  return fetch(process.env.REACT_APP_API_RB + url, {
    headers: {
      "x-access-token": token,
    },
    ...options,
  })
    .then(checkStatus)
    .then(parseJSON)
    .catch((err) => ({ err }));
}
// Funções auxiliares que você pode já ter definido (assumo que você tenha essas funções):
function checkStatus(response) {
  if (response.ok) {
    return response;
  } else {
    throw new Error(response.statusText);
  }
}

// Resposta 2xx sem corpo é sucesso, não erro: várias rotas de UPDATE da API
// respondem 200 com corpo vazio, e o response.json() quebrava com
// "Unexpected end of JSON input" — a tela avisava erro numa ação que tinha
// funcionado (ex.: Aprovar notícia).
async function parseJSON(response) {
  const texto = await response.text();
  return texto ? JSON.parse(texto) : null;
}

export async function getData(path, get, insert) {
  try {
    const currentPathWithQuery = `/${path}/${get}`;
    const response = await request(currentPathWithQuery, {
      method: "GET",
    });

    const data = { ...response, insert: insert, path: path };

    Object.keys(data).forEach((el, index) => {
      if (typeof data[el] === "number") {
        data[el] = data[el].toFixed(2);
        data[el] = data[el].replace(".", ",");
      }
    });

    console.log(data);
    return data;
  } catch (err) {
    throw new Error(err);
  }
}

export async function getDataWithEndpoint(path, get) {
  try {
    const currentPathWithQuery = `/${path}/${get}`;
    console.log(currentPathWithQuery);
    const response = await request(currentPathWithQuery, {
      method: "GET",
    });

    const data = { ...response };

    Object.keys(data).forEach((el, index) => {
      if (typeof data[el] === "number" && el !== "cot_id") {
        data[el] = data[el].toFixed(2);
        data[el] = data[el].replace(".", ",");
      } else if (typeof data[el] === "object") {
        // somente para bois por estado
        data[el][0].boi_valor = data[el][0].boi_valor.toFixed(2);
        data[el][0].boi_valor = data[el][0].boi_valor.replace(".", ",");
      }
    });

    console.log(data);
    return data;
  } catch (err) {
    throw new Error(err);
  }
}

export async function getDolarbyDate(date) {
  const arr = { data: { dataInicio: date } };

  const response = await request("/dolar/getDolarbyData", {
    method: "POST",
    body: JSON.stringify(arr),
  });
  console.log(response[0].dol_valor)
  return response[0].dol_valor;
}

/** Dia de Brasília (YYYY-MM-DD) de uma data vinda da API. */
export const diaBrasilia = (valor) =>
  new Date(valor).toLocaleDateString("sv-SE", { timeZone: "America/Sao_Paulo" });

/**
 * Dólar de cada dia de um período, numa requisição só.
 *
 * Os relatórios pediam o dólar com getDolarbyDate UMA VEZ POR LINHA, tudo
 * ao mesmo tempo: num relatório de "Todos" os estados por um mês eram
 * centenas de requisições simultâneas, parte delas falhava e a coluna de
 * dólar (ou o relatório inteiro) quebrava. Aqui vem o período inteiro de
 * uma vez, e cada linha procura o seu dia.
 *
 * Devolve uma função dia -> valor. Dia sem dólar usa o último dólar
 * anterior conhecido (é o que vale para fim de semana/feriado); antes do
 * primeiro, null.
 */
export async function getDolaresDoPeriodo(datas) {
  const dias = datas.filter(Boolean).map(diaBrasilia).sort();
  if (!dias.length) return () => null;
  // Uma semana antes do início, para ter o "último dólar anterior".
  const inicio = new Date(`${dias[0]}T12:00:00Z`);
  inicio.setUTCDate(inicio.getUTCDate() - 7);
  const response = await request("/dolar/getDolarbyData", {
    method: "POST",
    body: JSON.stringify({ data: { dataInicio: inicio.toISOString().slice(0, 10), dataFim: dias[dias.length - 1] } }),
  });
  const porDia = new Map();
  (Array.isArray(response) ? response : [])
    .slice()
    .sort((a, b) => new Date(a.dol_data) - new Date(b.dol_data))
    .forEach((d) => porDia.set(diaBrasilia(d.dol_data), d.dol_valor));
  const conhecidos = [...porDia.keys()].sort();
  return (valor) => {
    if (!valor) return null;
    const dia = diaBrasilia(valor);
    if (porDia.has(dia)) return porDia.get(dia);
    const anterior = conhecidos.filter((d) => d < dia).pop();
    return anterior ? porDia.get(anterior) : null;
  };
}

export async function getCommodityByOrder(order) {
  const response = await request(`/correcoes/getCommodityByOrdem/${order}`, {
    method: "GET",
  }).catch((error) => {
    console.error("Erro na requisição:", error);
  });
  return response[0];
}
